
import * as React from "react"
import { cva, type VariantProps } from "class-variance-authority"
import { cn } from "@/lib/utils"

const pageBadgeVariants = cva(
  "inline-flex items-center rounded-full border px-4 py-2 text-sm font-medium transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
  {
    variants: {
      variant: {
        default:
          "border-blue-200 bg-blue-50 text-blue-700 hover:bg-blue-100",
        secondary:
          "border-gray-200 bg-gray-50 text-gray-700 hover:bg-gray-100",
        outline: 
          "border-gray-300 bg-white text-gray-700 hover:bg-gray-50",
        gradient:
          "border-transparent bg-gradient-to-r from-blue-500 to-cyan-500 text-white shadow-lg hover:from-blue-600 hover:to-cyan-600",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
)

export interface PageBadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof pageBadgeVariants> {}

function PageBadge({ className, variant, ...props }: PageBadgeProps) {
  return (
    <div className={cn(pageBadgeVariants({ variant }), className)} {...props} />
  )
}

export { PageBadge, pageBadgeVariants }
